<template>
    <chart :chartData="chartData"/>
</template>
<script>
    import Chart from '../StatisticalInformation/Chart.vue';
    import { groupParties } from '../../functions/groupParties';
    import orderBy from 'lodash.orderby';

    export default {
        props: ['data', 'year'],
        components: {
            Chart
        },
        computed: {
            groupedData() {
                const data = [];
                this.data.forEach(d => {
                    const found = data.find(f => groupParties(f.Party, this.year) === groupParties(d.Party, this.year));
                    if (found) {
                        found.Count += d.Count;
                    } else {
                        data.push({...d, Party: groupParties(d.Party, this.year)});
                    }
                });
                // order by
                return orderBy(data, [d => d.Count, d => d.Party], ['desc', 'asc']);
            },
            chartData() {
                return {
                    chart: {
                        type: 'bar',
                        plotBackgroundColor: null,
                        plotBorderWidth: 0,
                        plotShadow: false,
                        backgroundColor: null,
                        height: 70
                    },
                    exporting: {
                        enabled: false
                    },
                    legend: {
                        enabled: false
                    },
                    title: {
                        text: undefined
                    },
                    xAxis: {
                        visible: false
                    },
                    yAxis: {
                        title: undefined,
                        labels: {
                            enabled: false
                        },
                    },
                    plotOptions: {
                        bar: {
                            stacking: 'percent',
                            borderRadius: 3
                        },
                    },
                    tooltip: {
                        formatter: function () {
                            return `${this.y} seats - (${this.series.userOptions.party})`
                        }
                    },
                    series: [...this.groupedData]
                        .reverse()
                        .map(d => ({
                        name: d.Party,
                        dataLabels: {
                            // enabled: true,
                            // align: i === 0 ? 'right' : 'left',
                            // format: '{point.percentage:.2f}%'
                        },
                        color: d.PartyColour,
                        party: d.Party,
                        data: [d.Count]
                    }))
                }
            },
        }
    }
</script>